import * as React from "react";

function SvgFileWord(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M19.12 5.09a3.11 3.11 0 01.62 1 3 3 0 01.25 1.2v15.43a1.26 1.26 0 01-.36.91 1.19 1.19 0 01-.89.37H1.25a1.18 1.18 0 01-.88-.37 1.27 1.27 0 01-.38-.91V1.29A1.27 1.27 0 01.37.38a1.19 1.19 0 01.88-.35h11.67a2.94 2.94 0 011.15.27 3.39 3.39 0 011 .64zm-.78 17.2V8.58h-5.42a1.17 1.17 0 01-.88-.38 1.23 1.23 0 01-.37-.91V1.72h-10v20.57zm-15.3-12v1.43h.95l2.1 8.86h2.07l1.66-6.5a2.6 2.6 0 00.13-.62 2.5 2.5 0 000-.32v.32s0 .12.05.27a1.77 1.77 0 00.07.35l1.66 6.5h2.07l2.14-8.86h1.05v-1.43h-3.93v1.43h1.18l-1.25 5.87a2.71 2.71 0 00-.09.62v.28h-.05v-.28c0-.05 0-.14-.05-.29s0-.25-.07-.33l-1.87-7.3h-1.6l-1.87 7.3q0 .12-.06.33V18.49v-.28a2.71 2.71 0 00-.09-.62l-1.47-5.87h1.22v-1.43zm10.3-8.46v5h4.89a1.46 1.46 0 00-.24-.52l-4.12-4.19a1.23 1.23 0 00-.53-.29z" />
    </svg>
  );
}

const MemoSvgFileWord = React.memo(SvgFileWord);
export default MemoSvgFileWord;
